// hooks/useTeammateCalculations.js - Teammate Calculations Hook
import { useMemo } from 'react';
import { hasDiscount } from '../../../helper';

const useTeammateCalculations = (product) => {
  const calculations = useMemo(() => {
    const discounted = typeof product['discount'] !== 'undefined' ? hasDiscount(product['discount']) : false;

    let discount = 0;
    const $weight = parseFloat(product['products']['accounting_weight']).toFixed(3);
    const $kasr = parseFloat((product['formula']['k'] * product['products']['accounting_weight']) / 100).toFixed(4);
    const $ojrat = parseFloat((product['formula']['o'] * product['products']['accounting_weight']) / 10).toFixed(2);
    const $stone_price = product['formula']['r'] / 10;

    if (discounted) {
      const withdiscount = ((parseInt(product['formula']['k']) - parseInt(product['discount']['percent'])) * parseFloat(product['products']['accounting_weight'])) / 100;
      const withoutdiscount = (parseInt(product['formula']['k']) * parseFloat(product['products']['accounting_weight'])) / 100;
      discount = withoutdiscount - withdiscount;
    }

    return {
      discount,
      $weight,
      $kasr,
      $ojrat,
      $stone_price,
    };
  }, [product]);

  return calculations;
};

export default useTeammateCalculations;
